// extracted by mini-css-extract-plugin
module.exports = {"container":"draggable__container___204J4"};